import React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Modal } from 'antd';
import { GenericTableView } from 'components';

const View = props => {
  const tag = props.tag;

  return (
    props.visible &&
    tag && (
      <Modal
        visible={true}
        destroyOnClose={true}
        onCancel={props.handleClose}
        title={`Product Tag: ${tag.name}`}
        okText="Close"
        onOk={props.handleClose}
      >
        <div>
          <img src={tag.asset.path} alt="" style={{ maxWidth: '100%' }} />
        </div>
        <GenericTableView
          viewObj={[
            {
              fields: [
                { label: 'Name', value: tag.name },
                { label: 'Description', value: tag.description },
                { label: 'Allow Filtering', value: tag.allowFiltering ? 'Yes' : 'No' }
              ]
            },
            {
              title: 'Audit Information',
              fields: [
                {
                  label: 'Created On',
                  value: tag.createdOn
                },
                {
                  label: 'Created By',
                  value: tag.createdBy && tag.createdBy.name ? tag.createdBy.name : ''
                },
                {
                  label: 'Updated On',
                  value: tag.updatedOn
                },
                {
                  label: 'Updated By',
                  value: tag.updatedBy && tag.updatedBy.name ? tag.updatedBy.name : ''
                }
              ]
            }
          ]}
        />
      </Modal>
    )
  );
};

export default View;
